import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { tenantKey } from '@/lib/queryClient'
import { useTenant } from '@/hooks/useTenant'
import { coaApi } from './api'
import type { SubcategoryPayload } from './types'

export function useCoa() {
  const tenantId = useTenant()
  return useQuery({
    queryKey: tenantKey(tenantId, 'coa'),
    queryFn: coaApi.list,
  })
}

export function useCreateSubcategory() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: (body: SubcategoryPayload) => coaApi.createSubcategory(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'coa') }),
  })
}

export function useUpdateSubcategory() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: SubcategoryPayload }) =>
      coaApi.updateSubcategory(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'coa') }),
  })
}

export function useDeleteSubcategory() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: (id: number) => coaApi.deleteSubcategory(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'coa') }),
  })
}

export function useRenameMainCategory() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: ({
      statementType,
      oldName,
      newName,
    }: {
      statementType: string
      oldName: string
      newName: string
    }) => coaApi.renameMainCategory(statementType, oldName, newName),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'coa') }),
  })
}

export function useDeleteMainCategory() {
  const qc = useQueryClient()
  const tenantId = useTenant()
  return useMutation({
    mutationFn: ({ statementType, name }: { statementType: string; name: string }) =>
      coaApi.deleteMainCategory(statementType, name),
    onSuccess: () => qc.invalidateQueries({ queryKey: tenantKey(tenantId, 'coa') }),
  })
}
